import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import React from 'react';
import { useStylesGeneral } from '../../styles/StyleComponents';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';

Checks.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.array, // Cambiado a array
};

Checks.defaultProps = {
  id: 'Custom',
  name: 'Custom',
  title: 'Custom',
  items: [{ value: 'TI' }, { value: 'HP' }],
  handleChange: () => { },
  value: [], // Cambiado a array vacío
};

function Checks(props) {
  const classes = useStylesGeneral();

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const newValue = props.value.includes(value)
      ? props.value.filter((v) => v !== value) // Si ya está seleccionado, lo quitamos
      : [...props.value, value]; // Si no, lo añadimos

    props.handleChange(newValue); // Llamamos a la función de cambio con el nuevo valor
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12}>
          <FormControl component="fieldset" style={{ width: "100%" }}>
            <FormLabel component="legend" style={{ fontWeight: 'bold', textAlign: "center", width: "100%" }}>
              {props.title}
            </FormLabel>
            <FormGroup row aria-label={props.name} name={props.name} className="center">
              {
                props.items.map((item) => (
                  <Tooltip key={item.value} title={item.Msg || ''} placement="bottom">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={item.value}
                          color="primary"
                          checked={props.value.includes(item.value)} // Verificamos si está seleccionado
                          onChange={handleCheckboxChange} // Usamos nuestra función de cambio
                        />
                      }
                      label={item.value}
                      labelPlacement="top"
                    />
                  </Tooltip>
                ))
              }
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
}

export default React.memo(Checks);
